import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class contabilidadPolizasexternasAlgodonerosIngresosListaMovimientosComponent {
  data
  vinculacion = false
  expandir = false
  procesando = false

  constructor(PolizasExternasAlgodonerosIngresos) {
    this.PolizasExternasAlgodonerosIngresos = PolizasExternasAlgodonerosIngresos
  }

  actualizarCodigo() {
    if (this.procesando) return

    this.procesando = true
    this.PolizasExternasAlgodonerosIngresos.put(this.data.id)
      .then(() => { this.data.codigoMovimiento = '152' })
      .finally(() => { this.procesando = false })
  }


  cerrarVinculacion(movimiento) {
    this.vinculacion = false
    this.onClose({ $event: movimiento })
  }

  actualizar($event) {
    if ($event) {
      this.data.facturas = $event.facturas
      this.data.totalvinculado = $event.totalvinculado
    }
  }
}

module.component('contabilidadPolizasexternasAlgodonerosIngresosListaMovimientos', {
  controller: contabilidadPolizasexternasAlgodonerosIngresosListaMovimientosComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/ingresos/lista/movimientos/component.js